import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { AsyncViewsNav } from '@jira/navigation-apps__horizontal-nav-jsm-views/src/index.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { getCalendarFilterFieldsResource } from '@jira/router-resources__service-desk-calendar/src/useCalendarFilterResource.tsx';
import { uifBoardResource } from '@jira/router-resources__uif-board/src/uifBoardResource.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { APP_NAMES, toPackageName } from '@jira/servicedesk__common/src/toPackageName.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { servicedeskCalendarRoute } from '@jira/router-routes__servicedesk-calendar-routes/src/servicedeskCalendarRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { ClassicCalendarSkeleton } from '@jira/platform__skeletons/src/ui/classic-calendar/ClassicCalendarSkeleton.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { calendarPageEntryPoint } from './ui/calendar/index.tsx';

export const servicedeskCalendarRouteEntry: Route = createEntry(servicedeskCalendarRoute, () => ({
	group: 'servicedesk',
	ufoName: 'jsm-calendar',
	// eslint-disable-next-line no-restricted-syntax
	component: () => null,
	skeleton: ClassicCalendarSkeleton,

	navigation: {
		menuId: MenuIdProjects,
		horizontal: AsyncViewsNav,
	},

	layout: serviceProjectLayout,

	resources: [
		...getServiceDeskNavigationResources(),
		...getServicedeskPageContextResources(),
		getConsolidationStateResource(),
		getCalendarFilterFieldsResource(),
		resourceWithCondition(() => !__SERVER__, uifBoardResource),
	],

	entryPoint: () => calendarPageEntryPoint,

	meta: {
		reporting: {
			id: 'calendar',
			packageName: toPackageName(APP_NAMES.CALENDAR),
			teamName: 'jsd-shield',
		},
	},

	supportsPreviewPanel: true,

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
